export enum ResponseEnum {
  OK = "OK",
  FAILURE = "FAILURE",
  ERROR_401 = "401"
}



// WEBPACK FOOTER //
// ./src/app/enums/ResponseEnum.enum.ts